import Image from "next/image";

import curveLineDown from "@/assets/img/ombudsman/right_curve.svg";
import { Bullet } from "@/components/Bullet/Bullet";
import { Box, Stack } from "@mui/material";

import { SecurityInformationBanner } from "../SecurityInformationBanner/SecurityInformationBanner";
import { SecurityScamSectionCard } from "../SecurityScamSectionCard";
import { styles } from "./styles";
import { SecurityScamSectionProps } from "./types";

export const SecurityScamSection: React.FC<SecurityScamSectionProps> = ({ commonScamsMainCards, commonScamsOtherCards, commonScamsTitle }) => {
  return (
    <Stack>
      <SecurityInformationBanner title={commonScamsTitle} />

      {commonScamsMainCards?.[0] ? (
        <SecurityScamSectionCard
          left={{
            topBulletColor: "#FFD100",
            bottomBulletColor: "#EF5AC3",
            image: commonScamsMainCards[0].image
          }}
          hideLeftTopLine={true}
          title={commonScamsMainCards[0].title}
          description={commonScamsMainCards[0].description}
          descriptionWithRichText={commonScamsMainCards[0].descriptionWithRichText}
        />
      ) : null}

      {commonScamsMainCards?.[1] ? (
        <SecurityScamSectionCard
          right={{
            topBulletColor: "#44E4FF",
            bottomBulletColor: "#FF5E43",
            image: commonScamsMainCards[1].image
          }}
          title={commonScamsMainCards[1].title}
          description={commonScamsMainCards[1].description}
          descriptionWithRichText={commonScamsMainCards[1].descriptionWithRichText}
        />
      ) : null}

      <Box mt="14px">
        {commonScamsMainCards?.[2] ? (
          <SecurityScamSectionCard
            left={{
              topBulletColor: "#44E4FF",
              bottomBulletColor: "#FFD100",
              image: commonScamsMainCards[2].image
            }}
            title={commonScamsMainCards[2].title}
            description={commonScamsMainCards[2].description}
            descriptionWithRichText={commonScamsMainCards[2].descriptionWithRichText}
          />
        ) : null}
      </Box>

      <Box css={styles.hotizontal_line} display={{ md: "none", xs: "inherit" }} />

      <Stack mt={{ md: "32px", xs: "0px" }} direction="row" position="relative">
        <Stack mr={{ md: "83px", xs: 0, width: "100%" }}>
          {commonScamsOtherCards?.map((card, index) => (
            <SecurityScamSectionCard
              key={index}
              title={card.title}
              description={card.description}
              descriptionWithRichText={card.descriptionWithRichText}
            />
          ))}
        </Stack>

        <Stack position="relative" marginTop="-35px" display={{ md: "inherit", xs: "none" }}>
          <Image
            src={curveLineDown}
            alt=""
            style={{
              position: "absolute",
              top: 0,
              right: "0px",
              backgroundColor: "#FFF",
              zIndex: 2
            }}
          />

          <Box css={styles.vertical_line} />

          <Box sx={{ width: 32, height: 32, position: "absolute", right: -14, bottom: -18, zIndex: 3 }}>
            <Bullet fillColor="#EF5AC3" />
          </Box>
        </Stack>

        <Box width="83px" bgcolor="#FFF" marginTop="-35px" display={{ md: "inherit", xs: "none" }} />
      </Stack>
    </Stack>
  );
};
